exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".theme--light.v-data-table tbody tr.selected-record{background:#f5f5f5}th>span{font-weight:700!important;font-size:larger!important;text-transform:uppercase}thead{border-bottom:2px solid #d3d3d3!important}", ""]);

// exports
